import { Svg } from './svg'

export const WandIcon = () => (
  <Svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4142 2.58579L12 0L10.5858 2.58579L8 4L10.5858 5.41421L12 8L13.4142 5.41421L16 4L13.4142 2.58579Z"
      fill="currentColor"
    />
    <path
      d="M9.70711 8.70711C10.0976 8.31658 10.0976 7.68342 9.70711 7.29289C9.31658 6.90237 8.68342 6.90237 8.29289
      7.29289L1.29289 14.2929C0.902369 14.6834 0.902369 15.3166 1.29289 15.7071C1.68342 16.0976 2.31658 16.0976
      2.70711 15.7071L9.70711 8.70711Z"
      fill="currentColor"
    />
    <path
      d="M3 3L4.06066 4.93934L6 6L4.06066 7.06066L3 9L1.93934 7.06066L0 6L1.93934 4.93934L3 3Z"
      fill="currentColor"
    />
    <path
      d="M13.9899 11.0101L13 9.5L12.0101 11.0101L10.5 12L12.0101 12.9899L13 14.5L13.9899 12.9899L15.5 12L13.9899 11.0101Z"
      fill="currentColor"
    />
  </Svg>
)
